import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authClient } from '../lib/auth-client';
import { Button, Card, CardBody, Input } from '@img/ui';

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await authClient.forgetPassword({
        email,
        redirectTo: `${window.location.origin}/reset-password`,
      });
      setSuccess(true);
    } catch (err) {
      setError((err as Error).message ?? 'فشل الإرسال');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--bg-light)]">
      <Card className="w-full max-w-md">
        <CardBody className="p-8">
          <div className="text-center mb-6">
            <Link to="/" className="inline-block bg-navy-dark text-white px-4 py-2 rounded-lg font-black mb-3">
              {t('app.name')}
            </Link>
            <h1 className="text-2xl font-black text-navy-dark">استعادة كلمة المرور</h1>
            <p className="text-sm text-gray-500 mt-1">سنرسل لك رابط لإعادة تعيين كلمة المرور</p>
          </div>

          {success ? (
            <div className="text-center py-8">
              <div className="text-5xl mb-3">📧</div>
              <h2 className="font-black text-navy-dark mb-2">تحقّق من بريدك</h2>
              <p className="text-sm text-gray-600">إذا كان البريد مسجّلاً عندنا، سيصلك رابط الاستعادة خلال دقائق.</p>
              <Link to="/login" className="inline-block mt-6 text-sm text-navy-dark font-bold hover:text-gold">
                ← العودة لتسجيل الدخول
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                label="البريد الإلكتروني"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg p-3">
                  {error}
                </div>
              )}
              <Button type="submit" variant="primary" size="lg" loading={busy} className="w-full">
                إرسال رابط الاستعادة
              </Button>
              <div className="text-center text-sm text-gray-600">
                <Link to="/login" className="text-navy-dark font-bold hover:text-gold">
                  ← العودة لتسجيل الدخول
                </Link>
              </div>
            </form>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
